import { useEffect, useState, createContext, useContext } from "react";
import api from "./api";

const SettingsCtx = createContext(null);

const DEFAULTS = {
  company_name: "AutoRIO",
  phone: "0753 567 030",
  phone_secondary: "0746 809 203",
  address_street: "Str. Mitocului Nr. 50",
  address_city: "Suceava",
  address_country: "România",
  schedule: "Luni – Vineri: 09:00 – 18:00 · Sâmbătă: 10:00 – 14:00 · Duminică: Închis",
  email: "contact@autorio.ro",
  whatsapp: "0753567030",
  facebook_url: "https://www.facebook.com/DealerAutoRIO",
  logo_url: "/autorio-logo.jpg",
  seo_title: "AutoRIO — Parc Auto Suceava",
  seo_description: "AutoRIO Suceava — autoturisme verificate, finanțare rapidă, garanție.",
  latitude: 47.6435,
  longitude: 26.2411,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, setSettings }}>{children}</SettingsCtx.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsCtx) || { settings: DEFAULTS, setSettings: () => {} };
}
